import React from "react";
import { Dispatch } from "react"
import { useSelector } from "react-redux"
import { actionCreators } from "../../../../../../../core/actions/configurator-actions";
import { IStore } from "../../../../../../../core/store"
import { strings } from "../../../../../../../localization/strings"
import { ParameterItem } from "../../../../components/ParameterItem"
import { InspectionUISettingsPivot } from "../../settings/InspectionUISettingsPivot";
import { IAIGradingConfig, IAIGradingDefaultConfig, ProcessStages } from "@piceasoft/core";

type TProps = {
    index: number
    stage: ProcessStages
    onChangeDispatch: Dispatch<any>
}

export const AIGradingUISettingsPivot: React.FC<TProps> = (props) => {
    const config = useSelector((s: IStore) => s.configurator.assessment?.modules.find(i => i.index === props.index)?.config as IAIGradingConfig)

    return (
        <InspectionUISettingsPivot stage={props.stage} index={props.index} onChangeDispatch={props.onChangeDispatch}>
            <ParameterItem title={strings.CONSTRUCTOR.INSPECTIONS.COMMON.PIVOTS.UI.DESCRIPTION_TITLE}
                useToggle
                toggleEnabled
                toggleChecked={config.config.ui?.description !== undefined ? true : false}
                toggleOnChange={() => {
                    props.onChangeDispatch(actionCreators.inspections.aigrading.editAIGrading(props.stage, props.index, {
                        ...config,
                        config: {
                            ...config.config,
                            ui: {
                                ...config.config.ui,
                                description: config.config.ui?.description !== undefined ? undefined : ""
                            }
                        } as IAIGradingDefaultConfig
                    }
                    ))
                }}
                description={strings.CONSTRUCTOR.INSPECTIONS.COMMON.PIVOTS.UI.DESCRIPTION_DESCRIPTION}
                useTextField
                textFieldMultiLimitSymbolsCount={40}
                textFieldEnabled={config.config.ui?.description !== undefined ? true : false}
                textFieldValue={config.config.ui?.description}
                textFieldOnChange={(val) => props.onChangeDispatch(actionCreators.inspections.aigrading.editAIGrading(props.stage, props.index, {
                    ...config,
                    config: {
                        ...config.config,
                        ui: {
                            ...config.config.ui,
                            description: val
                        }
                    } as IAIGradingDefaultConfig
                }
                )
                )}
            />
        </InspectionUISettingsPivot>

    )
}
